<template>
    <div class="container wordTempDiv" v-if="isVisible" style="z-index:1">
        <div class="wordTempDialog">
            <el-row>
                <el-col :span="24">
                    <div class="wordTempHeader">
                        {{currentTemplateName}}
                        <div class="wordTempHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-scrollbar :height="scrollHeight" :noresize="true">
                <div class="wordTempContainer">
                    <!--
                    <div class="wordTempContainerLeft">
                        <el-scrollbar :height="scrollHeight" :noresize="true">
                            <div class="diamond">
                                <div class="diamond_top_left"></div>
                                <div class="diamond_top_right"></div>
                            </div>
                            <div class="wordTempContainerLeftContent">
                                <p style="font-size:48px;text-align:center;font-family: 宋体;font-weight: bold;margin-top:300px;margin-bottom:20px">反担保保证合同</p>
                                <p style="line-height:40px;width:80%;font-size:21px;text-align:center;font-family: 宋体;border-top: 1px solid black;border-bottom: 1px solid black;margin: 0px auto;margin-bottom:300px;">合同编号：TY（2022）保字第025-1号</p>
                                <p style="line-height:40px;font-size:18px;text-align:center;font-family: 宋体;"><span style="font-weight: bold;">借款人：</span> <span style="text-decoration-line: underline;">枝江市银水水产养殖家庭农场</span></p>
                                <p style="line-height:40px;font-size:18px;text-align:center;font-family: 宋体;"><span style="font-weight: bold;">债权人：</span> <span style="text-decoration-line: underline;">湖北枝江农村商业银行股份有限公司</span></p>
                                <p style="font-size:21px;text-align:center;font-family: 宋体;font-weight: bold;margin-top:150px;margin-bottom:60px">枝江市天雨农业融资担保有限公司  制</p>

                                <p style="font-size:30px;line-height:80px;text-align:center;font-family: 宋体;font-weight: bold;margin-bottom:40px;border-top: 1px dashed black;">反担保保证合同</p>
                                <p style="font-size:19px;text-align:right;font-family: 宋体;margin-bottom:40px;padding-right: 7em;">合同编号：TY（2022）保字第025-1号</p>

                                <p style="padding-left: 9em;line-height:40px;font-size:18px;text-align:left;font-family: 宋体;"><span style="font-weight: bold;">甲  方：</span> <span style="text-decoration-line: underline;">枝江市天雨农业融资担保有限公司</span></p>
                                <p style="padding-left: 9em;line-height:40px;font-size:18px;text-align:left;font-family: 宋体;"><span style="font-weight: bold;">乙  方（反担保保证人）：</span> <span style="text-decoration-line: underline;">汪洋（身份证号42052319810525221X）</span></p>
                                <p style="padding-left: 9em;line-height:40px;font-size:18px;text-align:left;font-family: 宋体;">鉴于：</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">1.借款人枝江市银水水产养殖家庭农场已与甲方签订《委托担保合同》，甲方同意为借款人向湖北枝江农村商业银行股份有限公司（以下简称贷款银行）签订的编号为TY2022年马家店支行108号的借款合同，期限壹年（自银行实际放款日起算，实际放款日以借款凭证记载为准），金额为人民币大写：陆拾万元整（小写￥600000.00元，大小写不一致时，以大写为准，下同）的贷款提供连带保证担保。</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">2.为保障甲方在代借款人向贷款银行清偿债务后自身担保债权的实现，经双方充分协商，乙方自愿向甲方提供保证反担保，并承担连带保证责任。</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">为确定双方的权利义务，现根据《中华人民共和国民法典》之规定订立本合同。</p>

                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 黑体;">第一条  释义</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">1.本合同中的甲方是指反担保法律关系中接受乙方提供保证反担保的被保证人，也是为借款人提供保证担保的保证人。</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">2.本合同中的乙方是指反担保法律关系中的保证反担保人，即向甲方提供连带责任保证的保证人。</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">3.本合同中的借款人是指对贷款银行负有债务并由甲方为该债务提供了保证担保的被保证人。</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">4.本合同中的贷款银行是指对借款人拥有债权并接受了甲方提供的保证担保的贷款银行。</p>


                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 黑体;">第二条  担保方式</p>
                                <p style="padding:0 7em;text-indent: 2em;line-height:40px;font-size:21px;text-align:left;font-family: 宋体;">乙方同意在本合同约定的反担保范围内向甲方提供连带责任保证。</p>
                            </div>
                            <div class="diamond">
                                <div class="diamond_bottom_left"></div>
                                <div class="diamond_bottom_right"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="wordTempContainerRight">
                    </div>
                    -->
                    <el-form v-if="currentTemplateName==='反担保保证合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保合同编号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htbh">
                                            <el-input
                                                v-model="htExportWord1.htbh"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkr">
                                            <el-input
                                                v-model="htExportWord1.jkr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">债权人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="zqr">
                                            <el-input
                                                v-model="htExportWord1.zqr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    反担保保证人
                                </div>
                            </el-col>
                        </el-row>
                        <template v-if="htExportWord1.brzs&&htExportWord1.brzs.length>0">
                            <template v-for="(item,index) in htExportWord1.brzs" :key="item.Id">
                                <el-row v-if="item.Type === -1" >
                                    <el-col :span="2">
                                        <div class="bankAuditLB">保证人姓名：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent">
                                            <el-input
                                                v-model="item.Guarantor"
                                                size="small"
                                                placeholder="请输入保证人姓名">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">身份证号码：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent">
                                            <el-input
                                                v-model="item.GuarantorID"
                                                size="small"
                                                placeholder="请输入身份证号码">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                                </el-row>
                            </template>
                        </template>
                        <el-row>
                            <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemChange">+ 新增</el-button>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    借款信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款合同编号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkhtbh">
                                            <el-input
                                                v-model="htExportWord1.jkhtbh"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款期限（年）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkqx">
                                            <el-input
                                                v-model="htExportWord1.jkqx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（小写）元：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjexx">
                                            <el-input
                                                v-model="htExportWord1.jkjexx"
                                                size="small"
                                                placeholder=""
                                                @change="onDbjeChange">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（大写）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjedx">
                                            <el-input
                                                v-model="htExportWord1.jkjedx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    保证期限
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">期限信息：</div>
                                </el-col>
                                <el-col :span="21">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="qxxx">
                                            <el-input
                                                v-model="htExportWord1.qxxx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    担保物信息
                                </div>
                            </el-col>
                        </el-row>
                        <template v-if="htExportWord1.dbwxxs&&htExportWord1.dbwxxs.length>0">
                            <template v-for="(item,index) in htExportWord1.dbwxxs" :key="item.Id">
                                <el-row>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">担保物名称：</div>
                                    </el-col>
                                    <el-col :span="21">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="BdcNameContent">
                                                <el-input
                                                    v-model="item.BdcNameContent"
                                                    size="small"
                                                    placeholder="请输入保物名称">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <span class="removeTypeItem" @click="onRemoveLoanTypeChange(index)">×</span>
                                </el-row>
                            </template>
                        </template>
                        <el-row>
                            <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemLoanChange">+ 新增</el-button>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同份数
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">合同份数：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htfs">
                                            <el-input
                                                v-model="htExportWord1.htfs"
                                                size="small"
                                                placeholder="请输入合同份数，如：3">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同签订日期
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">签订日期：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htqdrq">
                                            <el-date-picker
                                                v-model="htExportWord1.htqdrq"
                                                size="small"
                                                type="date"
                                                placeholder="选择签订日期：">
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditOperate">
                                    <el-button size="small" type="success" @click="onExportWordChange1">导出合同</el-button>
                                    <el-button size="small" type="primary" @click="onFDDWord(1)">生成法大大合同</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>

                    <el-form v-if="currentTemplateName==='反担保抵押合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保合同编号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htbh">
                                            <el-input
                                                v-model="htExportWord1.htbh"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkr">
                                            <el-input
                                                v-model="htExportWord1.jkr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">债权人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="zqr">
                                            <el-input
                                                v-model="htExportWord1.zqr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    反担保保证人
                                </div>
                            </el-col>
                        </el-row>
                        <template v-if="htExportWord1.brzs&&htExportWord1.brzs.length>0">
                            <template v-for="(item,index) in htExportWord1.brzs" :key="item.Id">
                                <el-row v-if="item.Type === -1" >
                                    <el-col :span="2">
                                        <div class="bankAuditLB">保证人姓名：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="brzs">
                                                <el-input
                                                    v-model="item.Guarantor"
                                                    size="small"
                                                    placeholder="请输入保证人姓名">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">身份证号码：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="brzs">
                                                <el-input
                                                    v-model="item.GuarantorID"
                                                    size="small"
                                                    placeholder="请输入身份证号码">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                                </el-row>
                            </template>
                        </template>
                        <el-row>
                            <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemChange">+ 新增</el-button>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    借款信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款合同编号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkhtbh">
                                            <el-input
                                                v-model="htExportWord1.jkhtbh"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款期限（年）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkqx">
                                            <el-input
                                                v-model="htExportWord1.jkqx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（小写）元：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjexx">
                                            <el-input
                                                v-model="htExportWord1.jkjexx"
                                                size="small"
                                                placeholder=""
                                                @change="onDbjeChange">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（大写）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjedx">
                                            <el-input
                                                v-model="htExportWord1.jkjedx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    保证期限
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">期限信息：</div>
                                </el-col>
                                <el-col :span="21">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="qxxx">
                                            <el-input
                                                v-model="htExportWord1.qxxx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    抵押物信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">抵押物：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="dyw">
                                            <el-input
                                                v-model="htExportWord1.dyw"
                                                size="small"
                                                placeholder="水域、土地及地上建筑物。">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">抵押物总价值（万元）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="dywzjz">
                                            <el-input
                                                v-model="htExportWord1.dywzjz"
                                                size="small"
                                                placeholder="196">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    担保物信息
                                </div>
                            </el-col>
                        </el-row>
                        <template v-if="htExportWord1.dbwxxs&&htExportWord1.dbwxxs.length>0">
                            <template v-for="(item,index) in htExportWord1.dbwxxs" :key="item.Id">
                                <el-row>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">乙方{{(index+1)}}反担保抵押物：</div>
                                    </el-col>
                                    <el-col :span="20">
                                        <div class="bankAuditContent">
                                            <el-form-item prop="BdcNameContent">
                                                <el-input
                                                    type="textarea"
                                                    :autosize="{ minRows: 3, maxRows: 5}"
                                                    v-model="item.BdcNameContent"
                                                    size="small"
                                                    placeholder="请输入保物名称，如：
1.枝江市仙女镇向巷村股份经济合作社位于向巷村三组0.59亩土地及地上附属240.2平方米的建筑物吉吉果吧；
2.枝江市仙女镇向巷村股份经济合作社位于向巷村三组6.29亩土及地上附属820平方米集体农家乐房屋（其中3.44亩土地为周代年所有）；
3.枝江市仙女镇向巷村股份经济合作社位于仙女镇向巷村内合计424亩的水域。">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <span class="removeTypeItem" @click="onRemoveLoanTypeChange(index)">×</span>
                                </el-row>
                            </template>
                        </template>
                        <el-row>
                            <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemLoanChange">+ 新增</el-button>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同份数
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">合同份数：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htfs">
                                            <el-input
                                                v-model="htExportWord1.htfs"
                                                size="small"
                                                placeholder="请输入合同份数，如：3">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同签订日期
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">签订日期：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htqdrq">
                                            <el-date-picker
                                                v-model="htExportWord1.htqdrq"
                                                size="small"
                                                type="date"
                                                placeholder="选择签订日期：">
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditOperate">
                                    <el-button size="small" type="success" @click="onExportWordChange2">导出合同</el-button>
                                     <el-button size="small" type="primary" @click="onFDDWord(2)">生成法大大合同</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>

                    <el-form v-if="currentTemplateName==='委托担保合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保合同编号：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htbh">
                                            <el-input
                                                v-model="htExportWord1.htbh"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkr">
                                            <el-input
                                                v-model="htExportWord1.jkr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">债权人：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="zqr">
                                            <el-input
                                                v-model="htExportWord1.zqr"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款人通讯地址：</div>
                                </el-col>
                                <el-col :span="13">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="yfAddress">
                                            <el-input
                                                v-model="htExportWord1.yfAddress"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    委托担保信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">担保期限（年）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkqx">
                                            <el-input
                                                v-model="htExportWord1.jkqx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（小写）元：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjexx">
                                            <el-input
                                                v-model="htExportWord1.jkjexx"
                                                size="small"
                                                placeholder=""
                                                @change="onDbjeChange">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">借款金额（大写）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="jkjedx">
                                            <el-input
                                                v-model="htExportWord1.jkjedx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                          <el-col :span="3">
                            <div class="bankAuditLB">借款合同编号：</div>
                          </el-col>
                          <el-col :span="5">
                            <div class="bankAuditContent">
                              <el-form-item prop="jkjedx">
                                <el-input
                                    v-model="htExportWord1.jkhtbh"
                                    size="small"
                                    placeholder="">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    担保费用
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="4">
                                    <div class="bankAuditLB">每年担保费率为担保金额的（%）：</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="dbfl">
                                            <el-input
                                                v-model="htExportWord1.dbfl"
                                                size="small"
                                                placeholder=""
                                                @change="onDbflChange">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="bankAuditLB">担保费用共计小写（元）：</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="dbfyxx">
                                            <el-input
                                                disabled
                                                v-model="htExportWord1.dbfyxx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="bankAuditLB">担保费用共计大写：</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="dbfydx">
                                            <el-input
                                                disabled
                                                v-model="htExportWord1.dbfydx"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同份数
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">合同份数：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htfs">
                                            <el-input
                                                v-model="htExportWord1.htfs"
                                                size="small"
                                                placeholder="请输入合同份数，如：3">
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    合同签订日期
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                                <el-col :span="3">
                                    <div class="bankAuditLB">签订日期：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent">
                                        <el-form-item prop="htqdrq">
                                            <el-date-picker
                                                v-model="htExportWord1.htqdrq"
                                                size="small"
                                                type="date"
                                                placeholder="选择签订日期：">
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditOperate">
                                    <el-button size="small" type="success" @click="onExportWordChange3">导出合同</el-button>
                                     <el-button size="small" type="primary" @click="onFDDWord(3)">生成法大大合同</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>

                    <el-form v-if="currentTemplateName==='委托担保展期合同'" :rules="rules_htxx" ref="ruleForm" style="width: 100%" :model="htExportWord1">
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            合同信息
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">合同编号：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="htbh">
                              <el-input
                                  v-model="htExportWord1.htbh"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">借款人：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkr">
                              <el-input
                                  v-model="htExportWord1.jkr"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">债权人：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="zqr">
                              <el-input
                                  v-model="htExportWord1.zqr"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">借款合同编号：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkhtbh">
                              <el-input
                                  v-model="htExportWord1.jkhtbh"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">委托担保合同编号：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="wtdbhtbh">
                              <el-input
                                  v-model="htExportWord1.wtdbhtbh"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            反担保保证人
                          </div>
                        </el-col>
                      </el-row>
                      <template v-if="htExportWord1.brzs&&htExportWord1.brzs.length>0">
                        <template v-for="(item,index) in htExportWord1.brzs" :key="item.Id">
                          <el-row v-if="item.Type === -1" >
                            <el-col :span="2">
                              <div class="bankAuditLB">保证人姓名：</div>
                            </el-col>
                            <el-col :span="3">
                              <div class="bankAuditContent">
                                <el-input
                                    v-model="item.Guarantor"
                                    size="small"
                                    placeholder="请输入保证人姓名">
                                </el-input>
                              </div>
                            </el-col>
                            <el-col :span="2">
                              <div class="bankAuditLB">身份证号码：</div>
                            </el-col>
                            <el-col :span="5">
                              <div class="bankAuditContent">
                                <el-input
                                    v-model="item.GuarantorID"
                                    size="small"
                                    placeholder="请输入身份证号码">
                                </el-input>
                              </div>
                            </el-col>
                            <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                          </el-row>
                        </template>
                      <el-row>
                        <el-col :span="3">
                        <div class="bankAuditLB">反担保保证合同编号：</div>
                      </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="fdbbzhtbh">
                              <el-input
                                  v-model="htExportWord1.fdbbzhtbh"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        </el-row>
                      </template>
                      <el-row>
                        <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemChange">+ 新增</el-button>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            反担保质押人（新增）
                          </div>
                        </el-col>
                      </el-row>
                      <template v-if="htExportWord1.fdbzyr&&htExportWord1.fdbzyr.length>0">
                        <template v-for="(item,index) in htExportWord1.fdbzyr" :key="index">
                        <el-row>
                          <el-col :span="3">
                            <div class="bankAuditLB">反担保质押人：</div>
                          </el-col>
                          <el-col :span="5">
                            <div class="bankAuditContent">
                              <el-input
                                  v-model="item.name"
                                  size="small"
                                  placeholder="请输入反担保质押人">
                              </el-input>
                            </div>
                          </el-col>
                          <span class="removeTypeItem" @click="onRemoveItemFdbzyr(index)">×</span>
                        </el-row>
                      </template>
                        <el-row>
                          <el-col :span="3">
                            <div class="bankAuditLB">反担保抵押合同：</div>
                          </el-col>
                          <el-col :span="5">
                            <div class="bankAuditContent">
                              <el-form-item prop="fdbdyhtbh">
                                <el-input
                                    v-model="htExportWord1.fdbdyhtbh"
                                    size="small"
                                    placeholder="">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                      </template>
                      <el-row>
                        <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemFdbzyr">+ 新增</el-button>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            担保展期信息
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">原担保金额（小写）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkjexx">
                              <el-input
                                  v-model="htExportWord1.jkjexx"
                                  size="small"
                                  @change="onDbjeChange"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">原担保金额（大写）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkjedx">
                              <el-input
                                  v-model="htExportWord1.jkjedx"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">原担保期限（年）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkqx">
                              <el-input
                                  v-model="htExportWord1.jkqx"
                                  size="small"
                                  placeholder="年">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">展期担保金额（小写）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkjexxNew">
                              <el-input
                                  v-model="htExportWord1.jkjexxNew"
                                  size="small"
                                  @change="onDbjeZqChange"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">展期担保金额（大写）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkjedxNew">
                              <el-input
                                  v-model="htExportWord1.jkjedxNew"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditLB">展期担保期限（年）：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="jkqx">
                              <el-input
                                  v-model="htExportWord1.jkqxNew"
                                  size="small"
                                  placeholder="年">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">展期原因：</div>
                        </el-col>
                        <el-col :span="13">
                          <div class="bankAuditContent">
                            <el-form-item prop="zqyy">
                              <el-input
                                  v-model="htExportWord1.zqyy"
                                  size="small"
                                  @change="onDbjeChange"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            担保费用
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4">
                          <div class="bankAuditLB">每年担保费率为担保金额的（%）：</div>
                        </el-col>
                        <el-col :span="4">
                          <div class="bankAuditContent">
                            <el-form-item prop="dbfl">
                              <el-input
                                  v-model="htExportWord1.dbfl"
                                  size="small"
                                  placeholder=""
                                  @change="onDbflZqChange">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="bankAuditLB">担保费用共计小写（元）：</div>
                        </el-col>
                        <el-col :span="4">
                          <div class="bankAuditContent">
                            <el-form-item prop="dbfyxx">
                              <el-input
                                  disabled
                                  v-model="htExportWord1.dbfyxx"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="bankAuditLB">担保费用共计大写：</div>
                        </el-col>
                        <el-col :span="4">
                          <div class="bankAuditContent">
                            <el-form-item prop="dbfydx">
                              <el-input
                                  disabled
                                  v-model="htExportWord1.dbfydx"
                                  size="small"
                                  placeholder="">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            合同份数
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">合同份数：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="htfs">
                              <el-input
                                  v-model="htExportWord1.htfs"
                                  size="small"
                                  placeholder="请输入合同份数，如：3">
                              </el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            合同签订日期
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">签订日期：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-form-item prop="htqdrq">
                              <el-date-picker
                                  v-model="htExportWord1.htqdrq"
                                  size="small"
                                  type="date"
                                  placeholder="选择签订日期：">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <div class="bankAuditOperate">
                            <el-button size="small" type="success" @click="onExportWordChange4">导出合同</el-button>
                             <!-- <el-button size="small" type="primary" @click="onFDDWord(4)">生成法大大合同</el-button> -->
                          </div>
                        </el-col>
                      </el-row>
                    </el-form>

                  <el-form v-if="currentTemplateName==='质押反担保合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htbh">
                            <el-input
                                v-model="htExportWord1.htbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkr">
                            <el-input
                                v-model="htExportWord1.jkr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="zqr">
                            <el-input
                                v-model="htExportWord1.zqr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          反担保质押人（新增）
                        </div>
                      </el-col>
                    </el-row>
                      <template v-for="(item,index) in htExportWord1.fdbzyr" :key="index">
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">反担保质押人：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-input
                                v-model="item.name"
                                size="small"
                                placeholder="请输入反担保质押人">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveItemFdbzyr(index)">×</span>
                      </el-row>
                      </template>
                    <el-row>
                      <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemFdbzyr">+ 新增</el-button>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          借款信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款金额（小写）元：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkjexx">
                            <el-input
                                v-model="htExportWord1.jkjexx"
                                size="small"
                                placeholder=""
                                @change="onDbjeChange">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款金额（大写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkjedx">
                            <el-input
                                v-model="htExportWord1.jkjedx"
                                size="small"
                                @change="onDbjeChange"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkhtbh">
                            <el-input
                                v-model="htExportWord1.jkhtbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款期限（年）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkqx">
                            <el-input
                                v-model="htExportWord1.jkqx"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          质押信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dyw">
                            <el-input
                                v-model="htExportWord1.dyw"
                                size="small"
                                placeholder="库存商品及原材料">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物详情：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.dywxq"
                                size="small"
                                placeholder="示例：其中库存商品包括纯棉坏布、亚麻混纺类坯布、纯亚麻类坏布；原材料包括纯棉纱线、亚麻纺织纱线、纯亚麻纱线等">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物总价值：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dywzjz">
                            <el-input
                                v-model="htExportWord1.dywzjz"
                                size="small"
                                placeholder="万元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押期限描述：</div>
                      </el-col>
                      <el-col :span="13">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zyqx"
                                size="small"
                                placeholder="自本合同生效之日起至借款人贷款期限到期后三年或甲方向贷款银行承担保证责任后三年，以在后的时间为准。">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同份数
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">合同份数：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htfs">
                            <el-input
                                v-model="htExportWord1.htfs"
                                size="small"
                                placeholder="请输入合同份数，如：3">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同签订日期
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">签订日期：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htqdrq">
                            <el-date-picker
                                v-model="htExportWord1.htqdrq"
                                size="small"
                                type="date"
                                placeholder="选择签订日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditOperate">
                          <el-button size="small" type="success" @click="onExportWordChange5">导出合同</el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>

                  <el-form v-if="currentTemplateName==='最高额保证合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htbh">
                            <el-input
                                v-model="htExportWord1.htbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">合同代码：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htdm">
                            <el-input
                                v-model="htExportWord1.htdm"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">主债务人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkr">
                            <el-input
                                v-model="htExportWord1.jkr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          保证人
                        </div>
                      </el-col>
                    </el-row>
                    <template v-if="htExportWord1.brzs&&htExportWord1.brzs.length>0">
                      <template v-for="(item,index) in htExportWord1.brzs" :key="item.Id">
                        <el-row v-if="item.Type === -1" >
                          <el-col :span="3">
                            <div class="bankAuditLB">保证人姓名：</div>
                          </el-col>
                          <el-col :span="4">
                            <div class="bankAuditContent">
                              <el-form-item prop="brzs">
                                <el-input
                                    v-model="item.Guarantor"
                                    size="small"
                                    placeholder="请输入保证人姓名">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div class="bankAuditLB">身份证号码：</div>
                          </el-col>
                          <el-col :span="4">
                            <div class="bankAuditContent">
                              <el-form-item prop="brzs">
                                <el-input
                                    v-model="item.GuarantorID"
                                    size="small"
                                    placeholder="请输入身份证号码">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div class="bankAuditLB">联系电话：</div>
                          </el-col>
                          <el-col :span="4">
                            <div class="bankAuditContent">
                              <el-form-item prop="brzs">
                                <el-input
                                    v-model="item.Phone"
                                    size="small"
                                    placeholder="请输入联系电话">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                        </el-row>
                      </template>
                    </template>
                    <el-row>
                      <el-row>
                        <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemBzr">+ 新增</el-button>
                      </el-row>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          债权信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权起始时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqqssj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权终止时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqzzsj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>

                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（小写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgexx"
                                size="small"
                                @change="onZqjeChange"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（大写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgedx"
                                size="small"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同签订日期
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">签订日期：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htqdrq">
                            <el-date-picker
                                v-model="htExportWord1.htqdrq"
                                size="small"
                                type="date"
                                placeholder="选择签订日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditOperate">
                          <el-button size="small" type="success" @click="onExportWordChange6">导出合同</el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>

                  <el-form v-if="currentTemplateName==='最高额反担保抵押合同'" :rules="rules_htxx" ref="ruleForm" style="width:100%" :model="htExportWord1">
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htbh">
                            <el-input
                                v-model="htExportWord1.htbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkr">
                            <el-input
                                v-model="htExportWord1.jkr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="zqr">
                            <el-input
                                v-model="htExportWord1.zqr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          反担保抵押人（新增）
                        </div>
                      </el-col>
                    </el-row>
                    <template v-for="(item,index) in htExportWord1.fdbzyr" :key="index">
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">反担保抵押人：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-input
                                v-model="item.name"
                                size="small"
                                placeholder="请输入反担保质押人">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveItemFdbzyr(index)">×</span>
                      </el-row>
                    </template>
                    <el-row>
                      <el-row>
                        <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemFdbzyr">+ 新增</el-button>
                      </el-row>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          债权信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权起始时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqqssj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权终止时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqzzsj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>

                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（小写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgexx"
                                size="small"
                                @change="onZqjeChange"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（大写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgedx"
                                size="small"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          抵押物信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">抵押物：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dyw">
                            <el-input
                                v-model="htExportWord1.dyw"
                                size="small"
                                placeholder="水域、土地及地上建筑物。">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">抵押物总价值（万元）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dywzjz">
                            <el-input
                                v-model="htExportWord1.dywzjz"
                                size="small"
                                placeholder="196">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          担保物信息
                        </div>
                      </el-col>
                    </el-row>
                    <template v-if="htExportWord1.dbwxxs&&htExportWord1.dbwxxs.length>0">
                      <template v-for="(item,index) in htExportWord1.dbwxxs" :key="item.Id">
                        <el-row>
                          <el-col :span="3">
                            <div class="bankAuditLB">乙方{{(index+1)}}反担保抵押物：</div>
                          </el-col>
                          <el-col :span="20">
                            <div class="bankAuditContent">
                              <el-form-item prop="BdcNameContent">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 3, maxRows: 5}"
                                    v-model="item.BdcNameContent"
                                    size="small"
                                    placeholder="请输入保物名称，如：
1.枝江市仙女镇向巷村股份经济合作社位于向巷村三组0.59亩土地及地上附属240.2平方米的建筑物吉吉果吧；
2.枝江市仙女镇向巷村股份经济合作社位于向巷村三组6.29亩土及地上附属820平方米集体农家乐房屋（其中3.44亩土地为周代年所有）；
3.枝江市仙女镇向巷村股份经济合作社位于仙女镇向巷村内合计424亩的水域。">
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <span class="removeTypeItem" @click="onRemoveLoanTypeChange(index)">×</span>
                        </el-row>
                      </template>
                    </template>
                    <el-row>
                      <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemLoanChange">+ 新增</el-button>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同份数
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">合同份数：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htfs">
                            <el-input
                                v-model="htExportWord1.htfs"
                                size="small"
                                placeholder="请输入合同份数，如：3">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同签订日期
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">签订日期：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htqdrq">
                            <el-date-picker
                                v-model="htExportWord1.htqdrq"
                                size="small"
                                type="date"
                                placeholder="选择签订日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditOperate">
                          <el-button size="small" type="success" @click="onExportWordChange7">导出合同</el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>

                  <el-form v-if="currentTemplateName==='最高额质押合同'" :rules="rules_htxx" ref="ruleForm" style="width: 100%" :model="htExportWord1">
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htbh">
                            <el-input
                                v-model="htExportWord1.htbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkr">
                            <el-input
                                v-model="htExportWord1.jkr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权人：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="zqr">
                            <el-input
                                v-model="htExportWord1.zqr"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          反担保质押人（新增）
                        </div>
                      </el-col>
                    </el-row>
                    <template v-for="(item,index) in htExportWord1.fdbzyr" :key="index">
                      <el-row>
                        <el-col :span="3">
                          <div class="bankAuditLB">反担保质押人：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-input
                                v-model="item.name"
                                size="small"
                                placeholder="请输入反担保质押人">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveItemFdbzyr(index)">×</span>
                      </el-row>
                    </template>
                    <el-row>
                      <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="onAddItemFdbzyr">+ 新增</el-button>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          借款信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">借款合同编号：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="jkhtbh">
                            <el-input
                                v-model="htExportWord1.jkhtbh"
                                size="small"
                                placeholder="">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          债权信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权起始时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqqssj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权终止时间：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-date-picker
                                v-model="htExportWord1.zqzzsj"
                                size="small"
                                type="date"
                                placeholder="选择日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>

                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（小写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgexx"
                                size="small"
                                @change="onZqjeChange"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">债权最高额（大写）：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zqzgedx"
                                size="small"
                                placeholder="元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          质押信息
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dyw">
                            <el-input
                                v-model="htExportWord1.dyw"
                                size="small"
                                placeholder="库存商品及原材料">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物详情：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.dywxq"
                                size="small"
                                placeholder="示例：其中库存商品包括纯棉坏布、亚麻混纺类坯布、纯亚麻类坏布；原材料包括纯棉纱线、亚麻纺织纱线、纯亚麻纱线等">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押物总价值：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="dywzjz">
                            <el-input
                                v-model="htExportWord1.dywzjz"
                                size="small"
                                placeholder="万元">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">质押期限描述：</div>
                      </el-col>
                      <el-col :span="13">
                        <div class="bankAuditContent">
                          <el-form-item prop="">
                            <el-input
                                v-model="htExportWord1.zyqx"
                                size="small"
                                placeholder="自本合同生效之日起至借款人贷款期限到期后三年或甲方向贷款银行承担保证责任后三年，以在后的时间为准。">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同份数
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">合同份数：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htfs">
                            <el-input
                                v-model="htExportWord1.htfs"
                                size="small"
                                placeholder="请输入合同份数，如：3">
                            </el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditTitle">
                          <div class="bankAuditSplit"></div>
                          合同签订日期
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">
                        <div class="bankAuditLB">签订日期：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-form-item prop="htqdrq">
                            <el-date-picker
                                v-model="htExportWord1.htqdrq"
                                size="small"
                                type="date"
                                placeholder="选择签订日期：">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="bankAuditOperate">
                          <el-button size="small" type="success" @click="onExportWordChange8">导出合同</el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>

                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
    import indexJs from "./index.js";

    export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);

    .viewText {
        text-indent: 20px;
        height: 30px;
        line-height: 30px;
        padding: 15px 0px;
        text-align: left;
    }

    .viewRow {
        margin-left: 5%;
        width: 90%;
    }
</style>
